import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=af25de36&scoped=true"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"
import style0 from "./multiple.vue?vue&type=style&index=0&id=af25de36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af25de36",
  null
  
)

export default component.exports